// import PropTypes from "prop-types"
import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"

import {
  container,
  noMarginAbove as noMarginAboveStyles,
  noMarginBelow as noMarginBelowStyles,
  noPadding as noPaddingStyles,
} from "./styles.module.scss"

const Card = ({
  noMarginAbove,
  noMarginBelow,
  noPadding,
  extraClasses,
  children,
}) => (
  <section
    className={classNames(
      container,
      {
        [noMarginBelowStyles]: noMarginBelow,
        [noMarginAboveStyles]: noMarginAbove,
        [noPaddingStyles]: noPadding,
      },
      extraClasses,
    )}
  >
    {children}
  </section>
)

Card.propTypes = {
  noMarginAbove: PropTypes.bool,
  noMarginBelow: PropTypes.bool,
  noPadding: PropTypes.bool,
  extraClasses: PropTypes.string,
  children: PropTypes.node.isRequired,
}

Card.defaultProps = {
  noMarginAbove: false,
  noMarginBelow: false,
  noPadding: false,
  extraClasses: undefined,
}

export default Card
